// extracted by mini-css-extract-plugin
module.exports = {"seconds-container":"style_seconds-container__2KL3O","name":"style_name__JZcrP","number":"style_number__3FrZ9"};